import ClaimPage from '../pages/integration/ClaimPage';
import routeNames from '../constants/routeNames';

export const integrationRoutes = [
    {
        path: routeNames.CLAIM,
        name: 'ClaimPage',
        component: ClaimPage,
        exact: true,
        availableOnDesktop: true,
    },
];
